/**
 * AI Chatbot Components
 *
 * Exports all React components for the AI Chatbot feature.
 * Phase 7: Frontend Integration
 *
 * @module ChatbotComponents
 */

// Main widget
export { ChatWidget } from './ChatWidget';

// Widget parts
export { ChatBubble } from './ChatBubble';
export { ChatWindow } from './ChatWindow';

// Message components
export { MessageList } from './MessageList';
export { MessageItem } from './MessageItem';

// Input components
export { ChatInput } from './ChatInput';

// Feedback components
export { TypingIndicator } from './TypingIndicator';
export { SuggestionChips } from './SuggestionChips';

// Action components (Phase 18)
export { ActionConfirmationCard } from './ActionConfirmationCard';
export { ActionResultView } from './ActionResultView';
export { ProactiveSuggestionBadge } from './ProactiveSuggestionBadge';

// Entity link component (Phase 19B)
export { EntityLink } from './EntityLink';

// Spotlight overlay (Phase 19E)
export { SpotlightOverlay } from './SpotlightOverlay';

// Workflow progress (Phase 19F)
export { WorkflowProgressView } from './WorkflowProgressView';

// Contextual Help (Feature #55)
export { FieldHelpIcon, type FieldHelpIconProps } from './FieldHelpIcon';

// Training Simulator (Feature #56)
export { TrainingPanel } from './TrainingPanel';

// SOP Generator (Feature #54)
export { SopPanel } from './SopPanel';
